<script setup>
import { WIcon, WTooltip } from '@alice-health/wonderland-vue'

import { useStore } from '@/wrappers/store'

import NotificationGroup from '../NotificationGroup.vue'

const { mapActions } = useStore()
const { closeMenu } = mapActions('ui/channelBar')

defineProps({
  counters: { type: Object, default: undefined },
  config: { type: Object, required: true }
})

const emit = defineEmits(['click'])
const handleClick = () => {
  closeMenu()
  emit('click')
}
</script>

<template>
  <WTooltip :label="config.tooltipText" position="right">
    <router-link
      :data-testid="config.id"
      target="_self"
      :to="config.to"
      class="action-bar__item action-bar__item--fill"
      :active-class="config.exact ? undefined : 'action-bar__item--selected'"
      :data-dd-action-name="config.actionName"
      @click="handleClick"
    >
      <WIcon v-if="config.iconName" :icon="config.iconName" size="large" />
      <em v-else :class="config.iconClass"></em>
    </router-link>

    <NotificationGroup
      v-if="counters"
      :counters="counters"
      class="action-bar__counters"
    />
  </WTooltip>
</template>

<style lang="scss">
.action-bar {
  &__item {
    width: 64px;
    height: 64px;
    display: flex;
    place-items: center;
    place-content: center;
    cursor: pointer;

    &--selected {
      box-shadow: inset -2px 0 0 var(--icon-fill-selected);
    }
  }

  &__counters {
    position: absolute;
    top: var(--gl-spacing-02);
    right: var(--gl-spacing-02);
  }

  &__item--fill {
    color: var(--icon-fill);

    &:hover,
    &.action-bar__item--selected {
      color: var(--icon-fill-selected);
    }
  }
}

@media (max-width: 425px) {
  .action-bar__item--selected {
    box-shadow: inset 0 2px 0 0 var(--icon-fill-selected);
  }
}
</style>
